module.exports = __webpack_public_path__ + "img/CUBIC_LOGOHEADER.3728feed.png";